import { MotifCard, MotifCardBody, MotifIcon, MotifProgressBar } from '@ey-xd/motif-react'
import { MotifFab } from '@ey-xd/motif-react/components/button'

import iconSvg from "../../assets/icons/icon.svg.json";
import React from 'react'
import { useSelector } from 'react-redux';
import Image from '../atoms/Image';
import { BotUser } from 'src/config/assets';

const CoversationProgressbar = () => {
    const { inProgress } = useSelector((state: any) => state.conversations);

    if (!inProgress) {
        return <></>;
    }
    return (
        <div className="mb-5 !w-full">
            <div className={`flex gap-6`}>
                <div>
                    <Image alt="Bot User" src={BotUser} />
                </div>
                <div style={{ minWidth: "40%", maxWidth: "70%" }}>
                    <MotifCard className="!w-full">
                        <MotifCardBody>
                            <MotifProgressBar className="!w-full" isIndeterminate />
                        </MotifCardBody>
                    </MotifCard>
                </div>
            </div>
        </div>
    )
}

export default CoversationProgressbar